/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Marius Runde
 * Date: 05.07.2016
 *
 */

'use strict';
import { amdRequire } from 'plugin/liferay-widgets-react-web';
import L from 'external/leaflet';
import translateDraw from './DrawerPlugin/translate-leaflet-drawer';
import FeatureManager from '../utils/FeatureManager';
import { getBoundsFromGeometry } from '../utils/geo-utils';
import { boIcon } from '../..';

export default class GeometryInputPlugin {

    constructor(props) {
        if (props.onGeometryChange) {
            this.onGeometryChange = props.onGeometryChange.bind(this);
        } else {
            console.error('Required properties onGeometryChange are undefined!');
        }
        this.drawLayer = new L.FeatureGroup();
        this.boundRequestHandled = false;
        this.applyChanges = this.applyChanges.bind(this);
        this.block = this.block.bind(this);
        this.unBlock = this.unBlock.bind(this);
    }

    initOptions(o) {
        if (o.geometry && !this.boundRequestHandled) {
            o.boundRequest = {
                bounds: getBoundsFromGeometry(o.geometry),
                options: { animate: false },
                cb: () => this.boundRequestHandled = true
            };
        }
        return o;
    }

    init(map, o) {
        amdRequire([ 'leaflet-draw', 'css!leaflet-draw-css' ], () => {
            translateDraw();
            this.map = map;
            map.options.drawControl = true;
            map.addLayer(this.drawLayer);
            const control = new L.Control.Draw({
                draw: {
                    ...o.drawOptions,
                    rectangle: Liferay.Browser.isMobile() ? false : o.drawOptions.rectangle,
                    marker: o.drawOptions.marker !== undefined ? o.drawOptions.marker : { icon: boIcon(o.type) }
                },
                edit: {
                    featureGroup: this.drawLayer
                }
            });
            map.drawControl = control;
            map.addControl(control)
                .on(L.Draw.Event.CREATED, this.handleCreated.bind(this))
                .on(L.Draw.Event.EDITSTOP, this.applyChanges)
                .on(L.Draw.Event.DELETED, this.applyChanges);

            map.on(L.Draw.Event.DRAWSTART, this.block);
            map.on(L.Draw.Event.EDITSTART, this.block);
            map.on(L.Draw.Event.DELETESTART, this.block);

            L.DomUtil.toFront(control.getContainer());

            this.setGeometry(o);
        });
    }

    remove() {
        this.map = null;
        this.drawLayer = null;
    }

    setGeometry({ geometry, type }) {
        this.drawLayer.eachLayer(layer => layer.editing && layer.editing.disable()).clearLayers();
        if (geometry) {
            const feature = { geometry, type: 'Feature', properties: { type } };
            let layer = FeatureManager.createFeatureLayer(feature, {}, true);
            if (layer.then) {
                const loadingLayer = FeatureManager.loadingMarker(feature);
                layer.then((renderer) => {
                    this.drawLayer.removeLayer(loadingLayer);
                    this.drawLayer.addLayer(renderer.createFeatureLayer(feature, {}));
                });
                layer = loadingLayer;
            }
            this.drawLayer.addLayer(layer);
        }
        this.geometry = geometry;
    }

    getGeometry() {
        return this.drawLayer.getLayers().length > 0 ?
            this.drawLayer.getLayers()[ 0 ].toGeoJSON().geometry : null;
    }

    update(map, o) {
        if (o.geometry !== this.geometry) {
            this.setGeometry(o);
        }
    }

    block() {
        this.map.blockingControlActive = true;
    }

    unBlock() {
        /*
        hacky but Leaflet Draw ensures closing click for rectangle creation is
        propagated to map which triggers our LayerInfo plugin.
        https://github.com/Leaflet/Leaflet.draw/blob/develop/src/draw/handler/Draw.Rectangle.js#L52
        This ensures LayerInfo stays closed while drawing
         */

        setTimeout(() => {this.map.blockingControlActive = false;}, 300);
    }

    applyChanges(e) {
        this.onGeometryChange(this.getGeometry());
        this.unBlock();
    }

    handleCreated(e) {
        this.onGeometryChange(e.layer.toGeoJSON().geometry);
        this.unBlock();
    }
}





// WEBPACK FOOTER //
// ./js/plugins/GeometryInputPlugin.js